import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

//See: https://legacy.reactjs.org/docs/portals.html
//See: https://dev.to/ataparvinghods/react-portals-and-how-to-use-them-next-js-and-cra-2dic
//See: https://headlessui.com/react/dialog

type PortalProps = {
  children: React.ReactNode
}

const Portal = ({ children }: PortalProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    return () => {
      setMounted(false)
    }
  }, [])

  return mounted
    ? createPortal(children, document.querySelector('#portal-root') as Element)
    : null
}

export default Portal
